import { BackButton } from '@/components';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { AppRoutes } from '@/constants/routes';
import { MemberDetailView } from '@/features/SettingsView/components/MemberDetailView';

export default function SettingsMemberPage() {
    useDocumentTitle('settingsMember');

    return (
        <div className="h-full relative">
            <BackButton variant="floating" fallbackPath={AppRoutes.SETTINGS} />

            <div className="h-full overflow-y-auto px-4 panels:px-8">
                <div className="h-full flex flex-col items-center">
                    <div className="w-full max-w-content flex-1 min-h-0">
                        <MemberDetailView />
                    </div>
                </div>
            </div>
        </div>
    );
}
